import {
    DXP_XPERT_GET,
    DXP_XPERT_GET_ERROR,
    DXP_XPERT_SELECT,
    DXP_XPERT_ADD,
    DXP_XPERT_ADD_ERROR,
    DXP_XPERT_UPDATE,
    DXP_XPERT_UPDATE_ERROR,
    DXP_XPERT_DELETE,
    DXP_XPERT_DELETE_ERROR,
} from "../actions/types";

const initialState = {
    count: null,
    featuredXperts: [],
    selectedXpert: null,
    isLoading: true,
    success: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case DXP_XPERT_GET:
            return {
                ...state,
                featuredXperts: payload,
                isLoading: false,
                success: true,
            };
        case DXP_XPERT_SELECT:
            return {
                ...state,
                selectedXpert: payload,
                isLoading: false,
                success: true,
            };
        case DXP_XPERT_ADD:
        case DXP_XPERT_UPDATE:
        case DXP_XPERT_DELETE:
            return {
                ...state,
                isLoading: false,
                success: true,
            };
        case DXP_XPERT_GET_ERROR:
            return {
                ...state,
                featuredXperts: payload,
                isLoading: false,
                success: true
            }
        case DXP_XPERT_ADD_ERROR:
        case DXP_XPERT_UPDATE_ERROR:
        case DXP_XPERT_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                success: true
            }
        default:
            return state;
    }
}
